import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'BlueFreeShipmentInfo',
    props: {
        product_price: {
            type: Number,
            default: 0,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        cart_totals: 'cartTotals',
    })), { cart_products_total: function () {
            var _a, _b;
            return (_b = (_a = this.cart_totals) === null || _a === void 0 ? void 0 : _a.brutto_products) !== null && _b !== void 0 ? _b : 0;
        }, versandinfo() {
            if (this.product_price + this.cart_products_total < 30) {
                return 'Kostenloser Versand ab 30€';
            }
            return 'Kostenloser Versand';
        } }),
});
